import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import './projectLocaleList.scss';

import projectsStore from 'storeState/projects';
import generalStore from 'storeState/general';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import ATable from "views/aTable/ATable";
import Button from "views/button/Button";

import {formatDateTime} from 'service/LocaleService';

import _ from 'lodash';

export class ProjectLocaleList extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    componentDidMount() {

    }

    handleLocaleClick = (locale_id) => {
        if(this.props.onLocaleClick) {
            this.props.onLocaleClick(locale_id);
        }
    }

    render() {
        let locales = [];

        if(this.props.project && this.props.project.locales) {
            locales = this.props.project.locales;
            /*_.map(this.props.project.locales, (l) => {
                const lobj = _.find(this.props.locales, (lo) => lo.id == l.locale_id);
                return {
                    ...lobj,
                    project_locale_string_id: l.string_id
                }
            });*/
        }

        const localeKeys = locales ? _.sortBy(_.keys(locales), (k) => locales[k].project_locale_string_id) : [];

        return (
            <div className={`project-locale-list ${this.props.className ? this.props.className : ''}`}>
                <If condition={locales}>
                    <For each="key" of={localeKeys}>
                        <div onClick={() => this.handleLocaleClick(locales[key].project_locale_string_id)} className={`project-locale-list-item clickable ${this.props.value && this.props.value.project_locale_string_id == locales[key].project_locale_string_id ? 'project-locale-list-item-selected':''}`}>
                            <div className="project-locale-list-item-name">
                                {locales[key].display_name}&nbsp;[{locales[key].project_locale_string_id}]
                                <If condition={locales[key].missing>0}>
                                  <div class="project-locale-list-item-missing">
                                    <FormattedMessage
                                      id="project_locale_list.missing"
                                      defaultMessage="{n} missing"
                                      values={{
                                        "n": locales[key].missing
                                      }}
                                    />
                                  </div>
                                </If>
                                <If condition={locales[key].outdated>0}>
                                  <div class="project-locale-list-item-outdated">
                                    <FormattedMessage
                                      id="project_locale_list.outdated"
                                      defaultMessage="{n} outdated"
                                      values={{
                                        "n": locales[key].outdated
                                      }}
                                    />
                                  </div>
                                </If>
                                <If condition={locales[key].last_update}>
                                  <div class="project-locale-list-item-last-update">
                                    {formatDateTime(locales[key].last_update)}
                                  </div>
                                </If>
                            </div>
                            <div className="project-locale-list-item-date">

                            </div>
                        </div>
                    </For>
                </If>
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    locales: generalStore.selectors.locales(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, projectsStore.actions), dispatch)
  }
})(ProjectLocaleList)



// WEBPACK FOOTER //
// ./src/components/views/projectLocaleList/ProjectLocaleList.js